module.exports = __webpack_public_path__ + "img/thumbnail-8.1dbc1559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-8.jpg
// module id = N6hP
// module chunks = 1